<template>
  <div id="wang_editor" :textarea="textarea">

  </div>
</template>

<script>
import E from 'wangeditor'
export default {
  name: "WangEditor",
  props: {
    textarea: {
      type: String,
      default: ''
    }
  },
  data() {
    return{
      phoneEditor: '',
      name: '',

    }
  },
  mounted() {
    // wangeditor
    this.phoneEditor = new E('#wang_editor')
    // this.phoneEditor.onchange = function () {
    //   this.formData.phone = this.$txt.html()
    // }
    // 上传图片到服务器，base64形式
    // this.phoneEditor.customConfig.uploadImgShowBase64 = true
    // // 隐藏网络图片
    // this.phoneEditor.customConfig.showLinkImg = false
    // 创建一个富文本编辑器
    this.phoneEditor.config.zIndex = 0
    this.phoneEditor.create()
    // 富文本内容
    this.textarea = this.phoneEditor.txt.html()
  }
}
</script>

<style scoped>

</style>